"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordRequirementsCheck = void 0;
var react_1 = __importDefault(require("react"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Check_1 = __importDefault(require("@mui/icons-material/Check"));
var Box_1 = __importDefault(require("@mui/material/Box"));
/**
 * Component that renders an individual password complexity line item with check indicator.
 *
 * @param isChecked True if the line item should have a blue check (false for gray)
 * @param label text to display beside the check icon
 *
 * @category Component
 */
var PasswordRequirementsCheck = function (props) {
    var isChecked = props.isChecked, label = props.label;
    return (react_1.default.createElement(Box_1.default, { sx: { display: 'flex', alignItems: 'center' } },
        react_1.default.createElement(Check_1.default, { color: isChecked ? 'primary' : 'disabled', sx: { mr: 1 } }),
        react_1.default.createElement(Typography_1.default, { variant: 'subtitle2', sx: {
                fontWeight: 400,
                lineHeight: 1.2,
            } }, label)));
};
exports.PasswordRequirementsCheck = PasswordRequirementsCheck;
